import store from "store";

function groupItems(itemList, maxItems, type) {
    const itemGroups = [];
    let itemGroup = [];
    let currentItemCount = 1;
    itemList.forEach((item, index) => {
        if (type === "prescription") {
            itemGroup.push({ ...item, count: index + 1 });
        } else {
            itemGroup.push(item);
        }
        if (currentItemCount >= maxItems) {
            itemGroups.push(itemGroup);
            itemGroup = [];
            currentItemCount = 0;
        }
        currentItemCount++;
    });
    if (itemGroup.length !== 0) {
        itemGroups.push(itemGroup);
    }
    return itemGroups;
}

function prescriptionWriter(item, prescriptionNote, prescriptionWriting) {
    let prescriptionWrite = "";
    prescriptionWriting.forEach((writing) => {
        const { name, prefix, suffix, style, target } = writing;
        let value = "";

        //build styles
        let newStyle = null;
        switch (style) {
            case "bold":
                newStyle = "font-weight: bold";
                break;
            case "italic":
                newStyle = "font-style: italic";
                break;
            case "marginLeft20":
                newStyle = "margin-left: 20px";
                break;
            case "marginLeft50":
                newStyle = "margin-left: 50px";
                break;
            case "marginLeft100":
                newStyle = "margin-left: 100px";
                break;
            case "marginLeft200":
                newStyle = "margin-left: 200px";
                break;
            default:
                newStyle = "";
        }

        //get value
        if (target === "item") {
            value = item[name] ? item[name] : "";
        } else {
            value = prescriptionNote[name] ? prescriptionNote[name] : "";
        }

        if (name.indexOf("newline") !== -1) {
            prescriptionWrite += ` <span style="${newStyle}">${prefix}<br />${suffix}</span>`;
        } else {
            prescriptionWrite += ` <span style="${newStyle}">${
                value.trim() ? `${prefix}${value}${suffix}` : ""
            }</span>`;
        }
    });

    return `<span>${prescriptionWrite}</span>`;
}

function cleanPaperRows(paperRows) {
    return paperRows.map((paperRow) => {
        let newPaperRowContent = paperRow.content;
        newPaperRowContent = newPaperRowContent.replace(/\n/g, "");
        //newPaperRowContent = newPaperRowContent.replace(/>\s+</g, "><");
        return { ...paperRow, content: newPaperRowContent };
    });
}

function placeDetails(paperRows, allDetails) {
    //look for span tag and perform find and replace
    const processedPaperRows = paperRows.map((paperRow) => {
        //collate spans
        let newPaperRowContent = paperRow.content;

        let spans = newPaperRowContent.match(
            /<span data-role=".*?" data-lookup=".*?">.*?<\/span>/g
        );

        if (spans) {
            spans.forEach((span) => {
                let spanParts = span.match(
                    /<span data-role="(.*?)" data-lookup="(.*?)">/
                );
                let role = spanParts[1];
                let lookup = spanParts[2];
                if (
                    role &&
                    lookup &&
                    allDetails[lookup] &&
                    allDetails[lookup][role] !== undefined
                ) {
                    const strintToReplace = new RegExp(
                        `<span data-role="${role}" data-lookup="${lookup}">.*?</span>`
                    );
                    if (role === "signature" && lookup === "doctor") {
                        if (allDetails[lookup][role]) {
                            newPaperRowContent = newPaperRowContent.replace(
                                strintToReplace,
                                `<img alt="signature" src="${allDetails[lookup][role]}" />`
                            );
                        } else {
                            newPaperRowContent = newPaperRowContent.replace(
                                strintToReplace,
                                ""
                            );
                        }
                    } else {
                        newPaperRowContent = newPaperRowContent.replace(
                            strintToReplace,
                            allDetails[lookup][role]
                        );
                    }
                }
            });
        }

        return { ...paperRow, content: newPaperRowContent };
    });

    return processedPaperRows;
}

function placeRX(paperRows) {
    const processedPaperRows = paperRows.map((paperRow) => {
        let newPaperRowContent = paperRow.content;
        newPaperRowContent = newPaperRowContent.replace(
            '<span data-role="rx">rx</span>',
            '<img alt="rx" src="data:image/png;base64,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"/>'
        );
        return { ...paperRow, content: newPaperRowContent };
    });

    return processedPaperRows;
}

function placeItemList(paperRows, itemListHTML) {
    const processedPaperRows = paperRows.map((paperRow) => {
        let newPaperRowContent = paperRow.content;
        newPaperRowContent = newPaperRowContent.replace(
            '<span data-role="itemList">itemList</span>',
            itemListHTML
        );
        return { ...paperRow, content: newPaperRowContent };
    });

    return processedPaperRows;
}

function paperRowsToHTML(paperProps, paperRows) {
    let HTMLOutput = "";
    paperRows.forEach((paperRow) => {
        HTMLOutput += `<div style="${paperRow.style}">${paperRow.content}</div>`;
    });
    const { width, height, style } = paperProps;
    HTMLOutput = `<div style="width: ${width}px; height: ${height}px; ${style}">${HTMLOutput}</div>`;
    return HTMLOutput;
}

function openPaperPreviewWindow(html, isDirectPrint) {
    const windowWidth = 860;
    const windowHeight = 580;
    const windowXPos =
        window.top.outerWidth / 2 + window.top.screenX - windowWidth / 2;
    let paperPreviewWindow = window.open(
        "",
        "_blank",
        `width=${windowWidth},height=${windowHeight},top=10,left=${windowXPos},titlebar=no,menubar=no`
    );
    paperPreviewWindow.document.write(
        `<style>
                html * {
                    box-sizing: border-box;                    
                }
                body {
                    margin: 0;
                    line-height: 1.5715;
                    font-size: 14px;
                    font-family: "Times New Roman", Times, serif;                  
                }
                h1, h2, h3, h4, h5, h6, p {
                    margin: 0;
                    padding: 0;
                    border: 0;
                    font-size: 100%;
                    font: inherit;
                    vertical-align: baseline;
                }
                @media print
                {
                    .no-print, .no-print *
                    {
                        display: none !important;
                    }
                }
            </style>
            <div>
                ${
                    !isDirectPrint
                        ? `<div class="no-print" style="background-color:#1890ff; padding:10px;  color:#fff; display:flex; flex-direction: row; justify-content: space-between;"><div>Edit the contents below and then click the Print Preview button once done!</div><div><button onclick="window.print()">Print Preview</button></div></div>`
                        : ""
                }
                ${
                    !isDirectPrint
                        ? `<div contenteditable="true">${html}</div>`
                        : html
                }
            </div>`
    );
    if (isDirectPrint) {
        setTimeout(() => {
            paperPreviewWindow.print();
            paperPreviewWindow.close();
        }, 500);
    }
}

const printPrescription = (
    paperLayout,
    allDetails,
    isDirectPrint,
    prescriptions,
    isSaveToPatientPortal,
    doctorID,
    userID
) => {
    const paperProps = paperLayout.props;
    const paperRows = paperLayout.rows;
    let processedPaperRows = cleanPaperRows(paperRows);
    processedPaperRows = placeDetails(processedPaperRows, allDetails);
    processedPaperRows = placeRX(processedPaperRows);

    /*group prescription list to handle too many prescriptions
    (split into pages based on hard coded max item specified)*/
    let HTMLOutput = "";
    let prescriptionWriting = store.getState().Settings.prescriptionWriting;
    if (doctorID !== userID) {
        prescriptionWriting = store
            .getState()
            .UserDetails.doctors.find((doctor) => doctor.doctor_id === doctorID)
            .settings.prescription_writing;
    }
    const prescriptionGroups = groupItems(prescriptions, 4, "prescription");

    prescriptionGroups.forEach((prescriptions) => {
        let prescriptionGroupHtml = "";
        prescriptions.forEach((prescription) => {
            prescriptionGroupHtml += `<div style="margin-bottom: 8px;"><strong>${
                prescription.count
            }</strong> ${prescriptionWriter(
                prescription.item,
                prescription.note,
                prescriptionWriting
            )}</div>`;
        });
        let newProcessedPaperRows = placeItemList(
            processedPaperRows,
            prescriptionGroupHtml
        );
        HTMLOutput += paperRowsToHTML(paperProps, newProcessedPaperRows);
    });

    if (isSaveToPatientPortal) {
        return HTMLOutput;
    } else {
        openPaperPreviewWindow(HTMLOutput, isDirectPrint);
    }
};

const printRequests = (
    paperLayout,
    allDetails,
    isDirectPrint,
    requests,
    isSaveToPatientPortal
) => {
    const paperProps = paperLayout.props;
    const paperRows = paperLayout.rows;
    let processedPaperRows = cleanPaperRows(paperRows);
    processedPaperRows = placeDetails(processedPaperRows, allDetails);
    processedPaperRows = placeRX(processedPaperRows);

    /*group request list to handle too many requrest list
    (split into pages based on hard coded max item specified)*/
    let HTMLOutput = "";
    const requestGroups = groupItems(requests, 8, "requests");
    requestGroups.forEach((requests) => {
        let requestsGroupHtml = "";
        requests.forEach((request) => {
            requestsGroupHtml += `<div style="margin-bottom: 5px;">(&#10004;) ${request}</div>`;
        });
        let newProcessedPaperRows = placeItemList(
            processedPaperRows,
            requestsGroupHtml
        );
        HTMLOutput += paperRowsToHTML(paperProps, newProcessedPaperRows);
    });

    if (isSaveToPatientPortal) {
        return HTMLOutput;
    } else {
        openPaperPreviewWindow(HTMLOutput, isDirectPrint);
    }
};

const printPaper = (
    paperLayout,
    allDetails,
    isDirectPrint,
    isSaveToPatientPortal
) => {
    const paperProps = paperLayout.props;
    const paperRows = paperLayout.rows;
    let processedPaperRows = cleanPaperRows(paperRows);
    processedPaperRows = placeDetails(processedPaperRows, allDetails);
    processedPaperRows = placeRX(processedPaperRows);

    let HTMLOutput = paperRowsToHTML(paperProps, processedPaperRows);
    if (isSaveToPatientPortal) {
        return HTMLOutput;
    } else {
        openPaperPreviewWindow(HTMLOutput, isDirectPrint);
    }
};

export { printPrescription, printRequests, printPaper };
